export const key = "9834WEND$232JBDF80@433S3788N128$#2320987783232223PKBH42367BD734123#23&34*23BSDVSDS";




export const encrypt = (plaintext, key) => {
  let encryptedText = "";
  for (let i = 0; i < plaintext?.length; i++) {
    const charCode = plaintext?.charCodeAt(i) ^ key?.charCodeAt(i % key?.length);
    encryptedText += String.fromCharCode(charCode);
  }
  return encryptedText;
};

export const decrypt = (ciphertext, key) => {
  let decryptedText = "";
  for (let i = 0; i < ciphertext?.length; i++) {
    const charCode = ciphertext?.charCodeAt(i) ^ key?.charCodeAt(i % key?.length);
    decryptedText += String.fromCharCode(charCode);
  }
  
  var result = decryptedText.split(";").map((e) => e.split(":"));
  return result.map((subarray) => subarray.map((str) => str.trim()));
};
